import { EuiBasicTable, EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiFlexGrid } from '@elastic/eui';
import React, { useMemo, useState } from 'react';
import { CreateFecha, ToSQL } from '../../../../../shared/utils/fecha';


export const TablaDetalleHistoricoAdjuntosExpatriados = (props) =>{

    const {data, downloadAdjuntoUser, donwloadAllAdjuntosUser, translate} = props;

    const [itemIdToExpandedRowMap, setItemIdToExpandedRowMap] = useState({});

    const onDownloadAdjunto = (user,adjunto)=>{
      const userInfo = {idEmpleado:user.idEmpleado,empleado:user.empleado};
      const adjuntoInfo = {idAdjunto:adjunto.idAdjunto,nombre:adjunto.nombre,fechaDesde:ToSQL(adjunto.fechaDesde),fechaHasta:ToSQL(adjunto.fechaHasta)};
      const dataRequest = {user:userInfo,adjunto:adjuntoInfo}
      downloadAdjuntoUser(dataRequest)
    }

    const onDownloadAdjuntosUsuario = (user)=>{
      const userInfo = {idEmpleado:user.idEmpleado,fechaDesde:ToSQL(user.fechaDesde),fechaHasta:ToSQL(user.fechaHasta)};
      const dataRequest = {user:userInfo}
      donwloadAllAdjuntosUser(dataRequest)
    }

    const getAdjuntos = (item) => {

      const itemIdToExpandedRowMapValues = { ...itemIdToExpandedRowMap };
  
      if (itemIdToExpandedRowMapValues[item.idEmpleado]) {
        delete itemIdToExpandedRowMapValues[item.idEmpleado];
      } else {
        const { adjuntos} = item;
        

        const adjuntosList =  adjuntos.map((a)=> (
        <EuiFlexItem grow={false} className='adjunto-expatriado-info' onClick={()=> onDownloadAdjunto(item,a)}>
          <EuiFlexGroup alignItems='baseline'>
            <div className='adjunto-name' title={a.nombre}>{a.nombre}</div>
            <div className='adjunto-download'><EuiButtonIcon iconType='download' iconSize='s' onClick={()=> onDownloadAdjunto(item,a)}/></div>
          </EuiFlexGroup>
        </EuiFlexItem>
        ))
            // <EuiListGroupItem label={a.nombre}/>

        itemIdToExpandedRowMapValues[item.idEmpleado] = (
          <EuiFlexGrid alignItems='center'>
           {adjuntosList}
          </EuiFlexGrid>
          // <EuiListGroup>
          //   {adjuntosList}
          // </EuiListGroup>
        );
       
      }
      itemIdToExpandedRowMapValues[item.idEmpleado] && setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
    };

    const onClickDetalle = (idObj) =>{
      const itemIdToExpandedRowMapValues = { ...itemIdToExpandedRowMap };
      const _found = itemIdToExpandedRowMapValues[idObj.idEmpleado] ? true : false;
  
      if(_found){
        delete itemIdToExpandedRowMapValues[idObj.idEmpleado];
        setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
      }
      else{
        getAdjuntos(idObj)
      }
    }

    const isExpandible = (adjuntos) => adjuntos && adjuntos.length > 0; 

    const getUsers = useMemo(()=>{
      return data.empleados;
    },[data])

    const columns = [
      {
        width: '40px',
        isExpander: true,
        render: (item) => {
          return isExpandible(item.adjuntos) ? (
            <EuiButtonIcon
              className='btn-expand-cell'
              onClick={() => onClickDetalle(item)}
              aria-label={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idEmpleado]) ? 'Collapse' : 'Expand'}
              iconType={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idEmpleado]) ? 'arrowUp' : 'arrowDown'}
            />
          ):null
          }
      },
        {
            field: 'empleado',
            name: translate('empleado'),
            textOnly:true,
            truncateText: true,
            dataType: 'string',
            render: (data)=> data && <span title={data}>{data}</span>
        },
        {
            field: 'fechaDesde',
            name: translate('fecha-desde'),
            dataType: 'date',
            render: (date) => date && date && CreateFecha(date)
        },
        {
            field: 'fechaHasta',
            name: translate('fecha-hasta'),
            dataType: 'date',
            render: (date) => date && ( date === null ? '-' :CreateFecha(date))
        },
        {
            width:'60px',
            field: 'idAdjunto',
            name: ' ',
            dataType: 'number',
            render: (value, data) => { 
              return <EuiButtonIcon title={translate('descargar-todos-adjuntos')} className='btnDownload' onClick={()=>{onDownloadAdjuntosUsuario(data)}} iconType="download" size='m'></EuiButtonIcon>}
            
        }
       
      ];

    //   const getRowProps = (user) => {
    //     return {
    //     //   'data-test-subj': `row-${id}`,
    //       className: vb ? 'table-validacion-expatriados-row' : '',
    //       //onClick: () => {},
    //     };
    //   };

      return (
        <EuiBasicTable
          id='tabla-historico-adjuntos-expatriados'
          cellPadding={3}
          itemId="idEmpleado"
          tableCaption=""
          compressed={false}
          isExpandable={true}
          itemIdToExpandedRowMap={itemIdToExpandedRowMap}
          items={getUsers}
          columns={columns}
          responsive={true}
          //rowProps={getRowProps}
        />
      );
}